import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, browserHistory } from 'react-router';
import BlitzAPI from '../../api/BlitzAPI';
import UserForm from './UserForm';
import { handleFormErrors } from '../form/utils';

class UserEdit extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      user: null,
    };
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    BlitzAPI.getUser(this.props.params.userId).then(
      response => this.setState({ user: response.data.data }),
    );
  }

  handleSubmit(values) {
    return BlitzAPI.patchAnyUser(this.props.params.userId, { user: values }).then(
      response => browserHistory.push('/users'),
    ).catch(
      handleFormErrors,
    );
  }

  render() {
    if (!this.state.user) {
      return <div><h1>Loading</h1></div>;
    }
    console.log(this.state.user)
    return (
      <div>
        <h1>Edit User</h1>
        <UserForm onSubmit={this.handleSubmit} initialValues={this.state.user} />
      </div>
    );
  }
}

UserEdit.propTypes = {
  params: PropTypes.object,
};

export default withRouter(UserEdit);



// WEBPACK FOOTER //
// ./src/cms/user/UserEdit.js